<template>
	<label class="b-radio">
		<input
			type="radio"
			:disabled="disabled"
			:checked="value === optionValue"
			@change="handleChange"
		/>
		<div class="b-radio__radio" tabindex="0"></div>
		<div class="b-radio__label">
			<template v-if="$slots.label">
				<slot name="label" />
			</template>
			<template v-else>
				{{ label }}
			</template>
		</div>
	</label>
</template>

<script>
export default {
	name: "b-radio",
	props: {
		value: {
			type: [String, Number],
			default: null,
		},
		optionValue: {
			type: [String, Number],
			default: null,
		},
		label: {
			type: String,
			default: "",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {};
	},
	computed: {
		classes() {
			return [];
		},
	},
	methods: {
		handleChange(event) {
			if (this.disabled) {
				return;
			}
			if (event.target.checked) {
				this.$emit("input", this.optionValue);
			}
		},
	},
};
</script>

<style lang="scss">
.b-radio {
	display: flex;
	align-items: center;
	gap: 20px;
	cursor: pointer;

	input {
		display: none;
	}
}

.b-radio__radio {
	--size: 24px;
	width: var(--size);
	height: var(--size);
	border-radius: 50%;
	border: 1px solid var(--color-neutral-600);
	flex-shrink: 0;
}

.b-radio__label {
	color: var(--color-neutral-600);
	font-size: var(--font-size-m);
}

.b-radio:not(:has(:disabled)) {
	&:hover {
		.b-radio__radio {
			border-color: var(--color-neutral-900);
		}
	}

	&:has(:focus, :active, :checked) {
		.b-radio__radio {
			box-shadow: inset 0 0 0 6px var(--color-neutral-0);
		}
	}

	&:has(:focus) {
		.b-radio__radio {
			background-color: var(--color-primary-100);
		}
	}

	&:has(:checked, :active) {
		.b-radio__radio {
			background-color: var(--color-primary-600);
		}
	}

	&:has(:checked) {
		.b-radio__radio {
			border-color: var(--color-neutral-900);
		}
	}

	&:has(:active) {
		.b-radio__radio {
			border-color: var(--color-neutral-600);
		}
	}
}

.b-radio:has(:disabled) {
	cursor: not-allowed;

	.b-radio__radio {
		border-color: var(--color-neutral-150);
	}

	.b-radio__label {
		color: var(--color-neutral-300);
	}

	&:has(:checked) {
		.b-radio__radio {
			box-shadow: inset 0 0 0 6px var(--color-neutral-0);
			background-color: var(--color-neutral-150);
		}
	}
}
</style>
